import InfoSection from '../components/info_section';
import ScrollButton from '../components/scroll_button';
import { networkingList, toDoNetworkingList } from '../constants/networking';
import Layout from '../components/layout';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import styles from '../styles/networking.module.scss';
import Image from 'next/image';

export default function Networking() {
  const router = useRouter();
  const { t } = useTranslation('networking');

  const link = {
    en: <a rel='noopener' href='https://help.icdc.io/compute/en/Overview/Userprofile.html' target='_blank'>account</a>,
    ru: <a rel='noopener' href='https://help.icdc.io/compute/ru/Overview/Userprofile.html' target='_blank'>аккаунтa</a>
  };

  return (
    <Layout title={t('title')} lang={router.locale} route={router.route} isHeader isFooter>
        <ScrollButton scrollStepInPx='50' delayInMs='16.66' />
        <InfoSection title='Networking' description='networkingDescription' documentationLink='https://help.icdc.io/networking/' lang={router.locale} />

        <div className={styles.whatIsVpc}>
          <div>
            <h2>{t('whatIsVpc.title')}</h2>
            <p>{t('whatIsVpc.description1')} {link[router.locale]} {t('whatIsVpc.description2')}</p>
          </div>
          <div>
            <h2>{t('securityVpc.title')}</h2>
            <p>{t('securityVpc.description')}</p>
          </div>
        </div>

        <section className={styles.possibility}>
            <h2>{t('toDoNetworking.title')}</h2>
            <div className={styles.grid}>
              <div className={'flex ' + styles.possibility__list}>
                {
                  toDoNetworkingList.map((item, index) => (
                  <div key={index} className='flex'>
                      <Image src={item.img} alt={t(item.subtitle)} />
                    <div>
                        <h3>{t(item.subtitle)}</h3>
                      <p>{t(item.subdescription)}</p>
                      {index === 2 && <p>{t(item.subdescriptionSecond)}</p>}
                    </div>
                  </div>
                  ))
                }
              </div>
          <Image src='/networkinginterface.webp' alt='Networking interface' width={841} height={422} unoptimized loading='lazy' />
            </div>
        </section>

        <section className={styles.speed}>
          <div className='flex'>
          <h2>{t('speedVpc.title')}</h2>
            <p>{t('speedVpc.description')}</p>
          </div>
        </section>

        <section className={styles.benefits}>
            <h2>{t('benefits.title')}</h2>
            <div className={styles.benefits__list}>
              { networkingList.map((benefit, index) => (
                <div key={index}>
                  <h3>{t(benefit.subtitle)}</h3>
                  <p>{t(benefit.subdescription)}</p>
                </div>
              ))}
            </div>
        </section>

        <div className={'grid ' + styles.tools}>
        <h2>{t('workWithNetworking.title')}</h2>
          <div className={'grid ' + styles.tools__list}>
            { toDoNetworkingList.map((benefit, index) => (
              <div key={index} className='grid'>
                <Image src={benefit.img} alt={t(benefit.value)} />
                <p className='small-font'>{t(benefit.value)}</p> 
              </div>
            ))}
          </div>
          <a href='https://help.icdc.io/' target='_blank'>
            <button className='btn cloud'>{t('workWithNetworking.documentation')}</button>
          </a>
        </div>
    </Layout>
  )
};

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...await serverSideTranslations(locale, ['networking', 'common']),
  },
});
